import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Col, Row, Typography, Button, Image } from 'antd';
import { ArrowRightOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import StyledContainer from '../StyledContainer';
import BlogPost from './BlogPost';
import BlogPosts from './BlogData';

const { Title, Paragraph } = Typography;

const Blog = ({ i18, Language }) => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const activePost = slug ? BlogPosts.find((p) => p.slug === slug) : null;

  if (slug && !activePost) {
    // slug in URL doesn't match any post — handle gracefully
    return (
      <div style={{ background: '#fafafa', padding: '6rem 0', minHeight: '100vh', textAlign: 'center' }}>
        <StyledContainer>
          <Title level={3}>Post not found</Title>
          <Button onClick={() => navigate('/blog')}>{i18.BTN_BLOG_BACK_TOBLOG}</Button>
        </StyledContainer>
      </div>
    );
  }

  if (activePost) {
    return (
      <React.Fragment>
        <div style={{ background: '#fafafa', paddingTop: '6rem' }}>
          <StyledContainer>
            <Button
              type="text"
              icon={<ArrowLeftOutlined />}
              onClick={() => {
                navigate('/blog');
                window.scrollTo(0, 0);
              }}
              style={{ fontSize: '16px', marginBottom: '1rem' }}
            >
              {i18.BTN_BLOG_BACK_TOBLOG}
            </Button>
          </StyledContainer>
        </div>
        <BlogPost BlogPostData={activePost} Language={Language} />
      </React.Fragment>
    );
  }

  return (
    <div style={{ background: '#fafafa', padding: '6rem 0 4rem 0', minHeight: '100vh' }}>
      <StyledContainer>
        <Title level={2} style={{ textAlign: 'center', marginBottom: '3rem', fontSize: '2.5rem' }}>
          {i18.LNK_HEADER_BLOG}
        </Title>

        <Row gutter={[24, 24]}>
          {BlogPosts.map((post) => (
            <Col xs={24} sm={12} lg={8} key={post.slug}>
              <Card
                hoverable
                style={{
                  borderRadius: '12px',
                  overflow: 'hidden',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  boxShadow: '0 4px 15px rgba(0,0,0,0.02)'
                }}
                styles={{
                  body: { flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }
                }}
                cover={
                  post.banner ? (
                    <Image
                      src={post.banner}
                      preview={false}
                      placeholder={true}
                      style={{ maxHeight: '230px', transition: '0.3s ease', objectFit: 'cover' }}
                    />
                  ) : (
                    <div style={{ height: '200px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }} />
                  )
                }
              >
                <div>
                  <Title level={4} style={{ marginTop: 0, minHeight: '56px', lineClamp: 2 }}>
                    {post.title[Language]}
                  </Title>
                  <Paragraph type="secondary" ellipsis={{ rows: 3 }} style={{ marginBottom: '1.5rem' }}>
                    {post.content[Language]}
                  </Paragraph>
                </div>

                <Button
                  type="primary"
                  ghost
                  icon={<ArrowRightOutlined />}
                  onClick={() => {
                    navigate(`/blog/${post.slug}`);
                    window.scrollTo(0, 0);
                  }}
                  style={{ width: '100%', borderRadius: '6px' }}
                >
                  {i18.BTN_BLOG_READ_MORE}
                </Button>
              </Card>
            </Col>
          ))}
        </Row>
      </StyledContainer>
    </div>
  );
};

export default Blog;